import { FooterAllRights, FooterContainer, FooterLinks } from './style';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterLinks>
        <ul>
          <li>
            <a target="_blank" rel="noreferrer" href="https://primepass.zendesk.com/hc/pt-br/articles/360000317603-Pol%C3%ADtica-de-Privacidade">Política de privacidade</a>
          </li>
          <li>
            <a target="_blank" rel="noreferrer" href="https://primepass.zendesk.com/hc/pt-br/articles/4406906546964-Pol%C3%ADtica-de-Cookies">Cookies</a>
          </li>
          <li>
            <a target="_blank" rel="noreferrer" href="https://primepass.zendesk.com/hc/pt-br/articles/360000316626-Termos-de-Uso">Termos de uso</a>
          </li>
        </ul>
      </FooterLinks>
      <FooterAllRights>
        <p>&copy; Primepass - Todos os direitos reservados</p>
      </FooterAllRights>
    </FooterContainer>
  )
}

export default Footer;